/**
 * client/src/features/income/services/moneyBucketService.js
 * 
 * Compatibility layer for moneyBucketService to support existing components 
 * that depend on the old service structure.
 * This file redirects calls to the new bucketService implementation.
 */
import api from '../../../utils/api';

/**
 * Money Bucket Service
 * 🪣 Handles all bucket-related API calls
 */
const moneyBucketService = {
  // Get all buckets
  getAll: async () => {
    const response = await api.get('/api/buckets');
    return response.data;
  },

  // Create new bucket
  create: async (bucketData) => {
    const response = await api.post('/api/buckets', bucketData);
    return response.data;
  },

  // Get bucket details
  getDetails: async (id) => {
    const response = await api.get(`/api/buckets/${id}`);
    return response.data;
  },

  // Update bucket
  update: async (id, bucketData) => {
    const response = await api.put(`/api/buckets/${id}`, bucketData);
    return response.data;
  },

  // Delete bucket
  delete: async (id) => {
    const response = await api.delete(`/api/buckets/${id}`);
    return response.data;
  },

  // Add income to bucket
  addIncome: async (bucketId, incomeId) => {
    const response = await api.post(`/api/buckets/${bucketId}/income`, { incomeId });
    return response.data;
  },

  // Remove income from bucket
  removeIncome: async (bucketId, incomeId) => {
    const response = await api.delete(`/api/buckets/${bucketId}/income/${incomeId}`);
    return response.data;
  },

  // Reorder buckets
  reorderBuckets: async (bucketIds) => {
    const response = await api.put('/api/buckets/reorder', { bucketIds });
    return response.data;
  }
};

export default moneyBucketService; 